export const STOP_WORDS = new Set([
  'and',
  'or',
  'the',
  'for',
  'fund',
  'trust',
  'class',
  'pty',
  'ltd',
  'inc',
]);

/** Tokens too generic to link alone (even when long enough). */
export const GENERIC_FUND_TOKENS = new Set([
  ...STOP_WORDS,
  'senior',
  'debt',
  'investment',
  'opportunity',
  'mezzanine',
  'portfolio',
  'multifamily',
  'prime',
  'series',
  'stage',
  'units',
  'registered',
  'mortgage',
  'preferred',
  'equity',
  'junior',
  'residential',
  'industrial',
  'commercial',
  'built',
  'alternative',
  'land',
  'retail',
  'office',
  'prod',
  'east',
  'west',
  'north',
  'south',
  'holdings',
  'company',
  'family',
  'individual',
]);

export const MIN_SIGNATURE_TOKEN_LENGTH = 4;
export const MAX_LINKS_PER_MESSAGE = 5;
